import type { FC } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import { Icon } from '../Icon/Icon';
import { getSystemButtonClassNames } from './SystemButton.styles';
import {
  type SystemButtonProps,
  fromSystemButtonToIconSize,
} from './SystemButton.types';

export const SystemButton: FC<SystemButtonProps> = ({
  size = 'default',
  icon,
  iconProps,
  className,
  buttonRef,
  disabled,
  onClick,
  loading,
  dataTestId,
  ...otherProps
}) => {
  const buttonDisabled = loading || disabled;
  return (
    <button
      {...otherProps}
      className={getSystemButtonClassNames(size, className, buttonDisabled)}
      data-testid={dataTestId}
      type='button'
      disabled={buttonDisabled}
      ref={buttonRef}
      onClick={onClick}
      tabIndex={getAccessibleTabIndex(buttonDisabled)}
    >
      <Icon
        glyph={icon}
        {...iconProps}
        loading={loading}
        size={fromSystemButtonToIconSize[size]}
      />
    </button>
  );
};
